import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/index.css'
import '@/assets/font/iconfont.css'
import 'lib-flexible'
import '@/utils/detectZoom'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import webHead from '@/layout/component/webHead.vue'

Vue.config.productionTip = false
Vue.component('webHead', webHead)
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
